import moment from "moment";
import React from "react";
import { useSelector } from "react-redux";
import EventPreview from "../../Components/EventPreview";

export default function Day({ dayOfWeek, clickEvent }) {
  const events = useSelector((state) =>
    state.calendar.events.filter((e) => e.days[dayOfWeek])
  );

  return (
    <div style={{ width: `${100 / 7}%` }}>
      {moment().day(dayOfWeek).format("dddd")}
      <div style={{ height: "500px", position: "relative" }}>
        {events.map((e) => (
          <EventPreview event={e} onClick={clickEvent} />
        ))}
      </div>
    </div>
  );
}
